import { FontAwesome5 } from "@expo/vector-icons";
import { Icon, useTheme } from "native-base";
import React, { useEffect, useRef, useState } from "react";
import {
	Animated,
	Dimensions,
	ImageBackground,
	SafeAreaView,
	View,
} from "react-native";
import { getCarouselImages } from "../../utils/utils";

const { width, height } = Dimensions.get("window");

const MobileCarousel = () => {
	const { colors } = useTheme();
	const flatListRef = useRef();
	const [currentPage, setCurrentPage] = useState(0);
	const [viewableItems, setViewableItems] = useState([]);

	const handleViewableItemsChanged = useRef(({ viewableItems }) => {
		setViewableItems(viewableItems);
	});
	useEffect(() => {
		if (!viewableItems[0] || currentPage === viewableItems[0].index) return;
		setCurrentPage(viewableItems[0].index);
	}, [viewableItems]);

	const data = [
		{
			id: "1",
			img: require("../../../assets/Vivo-how/Vivo-step1.png"),
		},
		{
			id: "2",
			img: require("../../../assets/Vivo-how/Vivo-step2.png"),
		},
		{
			id: "3",
			img: require("../../../assets/Vivo-how/Vivo-step3.png"),
		},
		{
			id: "4",
			img: require("../../../assets/Vivo-how/Vivo-step4.png"),
		},
		{
			id: "5",
			img: require("../../../assets/Vivo-how/Vivo-step5.png"),
		},
		{
			id: "6",
			img: require("../../../assets/Vivo-how/Vivo-step6.png"),
		},
	];

	const renderBottomSection = () => {
		return (
			<SafeAreaView>
				<View
					style={{
						flexDirection: "row",
						justifyContent: "space-between",
						alignItems: "center",
						paddingHorizontal: 12,
						paddingVertical: 12,
						// backgroundColor: "pink",
					}}
				>
					<View
						style={{
							flex: 1,
							flexDirection: "row",
							alignItems: "center",
							justifyContent: "center",
						}}
					>
						{
							// No. of dots
							[...Array(getCarouselImages().length)].map((_, index) => (
								<View
									key={index}
									style={{
										borderColor: colors.primary["200"],
										borderWidth: 1,
										width: 6,
										height: 6,
										borderRadius: 3,
										backgroundColor:
											index == currentPage ? colors.primary["500"] : "#fff",
										marginRight: 12 * 2,
									}}
								/>
							))
						}
					</View>
				</View>
			</SafeAreaView>
		);
	};

	const renderFlatlistItem = ({ item }) => {
		return (
			<View
				style={{
					width: width / 1.1,
					height: height / 2,
					// flex: 1,
					alignItems: "center",
					justifyContent: "center",
					marginBottom: 10,
					// backgroundColor: "gold",
				}}
			>
				<View
					style={{
						alignItems: "center",
						// marginVertical: 5 * 2,
					}}
				>
					<ImageBackground
						source={item.img}
						style={{
							width: width,
							height: height / 2.1,
							resizeMode: "contain",
						}}
					>
						{currentPage !== getCarouselImages().length - 1 && (
							<Icon
								style={{
									alignSelf: "flex-end",
									flexDirection: "row",
									// marginTop: height / 2.4,
									shadowColor: "#000",
									shadowOffset: { width: 0, height: 2 },
									shadowOpacity: 0.5,
									shadowRadius: 2,
									elevation: 5,
									marginRight: 15,
								}}
								as={FontAwesome5}
								name="chevron-down"
								size="lg"
								color={colors.primary["500"]}
							/>
						)}
						{currentPage === getCarouselImages().length - 1 && (
							<Icon
								style={{
									alignSelf: "flex-end",
									flexDirection: "row",
									// marginTop: height / 2.6,
									shadowColor: "#000",
									shadowOffset: { width: 0, height: 2 },
									shadowOpacity: 0.5,
									shadowRadius: 2,
									elevation: 5,
									marginRight: 15,
								}}
								as={FontAwesome5}
								name="chevron-up"
								size="lg"
								color={colors.primary["500"]}
							/>
						)}
					</ImageBackground>
				</View>
			</View>
		);
	};

	return (
		<View style={{ marginTop: 50 }}>
			<Animated.FlatList
				data={getCarouselImages()}
				// horizontal
				showsHorizontalScrollIndicator={false}
				showsVerticalScrollIndicator={false}
				keyExtractor={(item) => item.id}
				renderItem={renderFlatlistItem}
				ref={flatListRef}
				onViewableItemsChanged={handleViewableItemsChanged.current}
				// viewabilityConfig={{ viewAreaCoveragePercentThreshold: 100 }}
				initialNumToRender={1}
				extraData={width}
			/>
			{renderBottomSection()}
		</View>
	);
};

export default MobileCarousel;
